import { all, takeLatest } from 'redux-saga/effects';
import { fetchKarmaEarnOffer } from '../actions';
import fetchWorker from './worker.fetch';

function* karmaEarnSaga() {
  yield all([takeLatest(fetchKarmaEarnOffer, fetchWorker)]);
}

export default karmaEarnSaga;
